import { Typography } from "@material-tailwind/react"
import React, { useEffect, useState } from "react"
import HeaderIcon from "./HeaderIcon"
import { UserType } from "../../types/user"
import { DEFAULTPRIMARYCOLOR } from "../../util"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../store/store"
import { getColorCode } from "../../colorCodes"
import { Link, useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import { clearAuthState } from "../../store/features/authSlice"

export const CustomHeader = ({
  title,
  description,
}: {
  title: string
  description?: string
}) => {
  const {
    user: stateUser,
  } = useSelector((state: RootState) => state.auth)


  const [colors, setColors] = useState<string[]>();


  // const userData = localStorage.getItem("user");
  useEffect(() => {
    if (stateUser) {
      const colors = getColorCode(stateUser?.colors)
      setColors(colors);
    }
  }, [stateUser]);

  // console.log("colors", colors)
  const dispatch = useDispatch();
  const history = useHistory();
  const [openMenu, setOpenMenu] = useState(false);

  const handleLogout = async () => {
    try {
      dispatch(clearAuthState());
      localStorage.removeItem("authState");
      localStorage.clear();

      // localStorage.clear()
      history?.push("/login");
    } catch (error) {
      toast.error("Failed to log out");
    }
  };

 
  return (
    <div className="sticky top-0 z-40 mb-5 w-full">
  <div className="py-3 bg-white rounded-lg shadow-sm px-3 sticky top-0 z-50 w-full flex flex-row flex-wrap items-center justify-between">
    {/* HeaderIcon - visible first only on mobile */}
    <div className="order-1 block lg:hidden mr-10">
      <HeaderIcon />
    </div>

    {/* Title and description */}
    <div className="order-2 flex-1">
      <Typography
        style={{
          color: "#4F46E5",
        }}
        className="capitalize font-bold text-lg lg:text-xl"
      >
        {title}
      </Typography>
      {description && (
        <span className="text-sm text-gray-600">{description}</span>
      )}
    </div>

    {/* HeaderIcon for large screens (hidden on mobile) */}
    <div className="order-1 hidden lg:block">
      <HeaderIcon />
    </div>

    {/* User info and menu toggle */}
    <div
      className="order-3 flex items-center gap-2 cursor-pointer"
      onClick={() => setOpenMenu(!openMenu)}
    >
      <Typography className="text-sm font-semibold text-gray-700">
        {stateUser?.name}
      </Typography>
      <div className="w-[40px] rounded-full bg-gray-100 shadow-md flex justify-center items-center bg-cover h-[40px]">
        <img src={stateUser?.logo_url} alt="Logo" className="" />
      </div>
    </div>

    {/* Dropdown menu */}
    {openMenu && (
      <div className="absolute top-14 right-0 w-40 bg-white rounded-lg shadow-xl p-2">
        <div className="flex flex-col p-2">
          <Link to="/dashboard/settings">
            <div
              className={`hover:${
                colors?.length! > 1
                  ? `bg-${stateUser?.colors![1]?.toLowerCase()}-200`
                  : "bg-blue-400"
              } flex flex-col items-start gap-2 cursor-pointer w-full p-2 rounded-lg`}
            >
              <Typography className="text-sm font-semibold text-gray-700">
                Settings
              </Typography>
            </div>
          </Link>

          <div className="border-b border-gray-200 my-2"></div>

          <div
            className={`hover:${
              colors?.length! > 1
                ? `bg-${stateUser?.colors![1]?.toLowerCase()}-200`
                : "bg-blue-400"
            } flex flex-col items-start gap-2 cursor-pointer w-full p-2 rounded-lg`}
            onClick={handleLogout}
          >
            <Typography className="text-sm font-semibold text-red-700">
              Logout
            </Typography>
          </div>
        </div>
      </div>
    )}
  </div>
</div>

  )
}